import { useTranslation } from "react-i18next"
import { ReusableWizard } from "@oysterhr/feature-components"
import { BankDetailsStep } from "./steps/BankDetailsStep"
import { AuthorizeDebitStep } from "./steps/AuthorizeDebitStep"
import { Pearl, PearlProvider } from "@oysterhr/pearl"
import { useLocation, useParams } from "react-router-dom"
import { ErrorPage } from "~/shared/pages/system/ErrorPage"
import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"
import { NewSepaAdvisor } from "./components/NewSepaAdvisor"
import { SepaAdvisorStep } from "./components/NewSepaAdvisor/NewSepaAdvisor"

const PAGE_TO_STEP_MAP: Record<number, SepaAdvisorStep> = {
  1: "bank-details",
  2: "authorization",
}

const NewSepaFlowPage = () => {
  const { paymentMethodType } = useParams()
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")
  const location = useLocation()

  // Get the page through search params set by Wizard in URL
  const searchParams = new URLSearchParams(location.search)
  const page = searchParams.get("page") ?? 1

  if (!paymentMethodType) return <ErrorPage errorCode="404" />

  return (
    <PearlProvider>
      <ConnectPaymentMethodLayout title={t("title")}>
        <ReusableWizard>
          <BankDetailsStep />
          <AuthorizeDebitStep />
        </ReusableWizard>
        <div className="text-left">
          <Pearl name="sepa-flow-page">
            <Pearl.SideBox>
              <NewSepaAdvisor step={PAGE_TO_STEP_MAP[Number(page)]} />
            </Pearl.SideBox>
          </Pearl>
        </div>
      </ConnectPaymentMethodLayout>
    </PearlProvider>
  )
}

export default NewSepaFlowPage
